import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Phone = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M11 40V8h26v32H11Zm-.125-36C8.615 4 7 5.914 7 8v32c0 2.086 1.615 4 3.875 4h26.25C39.385 44 41 42.086 41 40V8c0-2.086-1.615-4-3.875-4h-26.25Zm8.1 12h10.05C30.13 16 31 15.153 31 14.048v-.033C31 12.91 30.13 12 29.025 12h-10.05C17.87 12 17 12.847 17 13.952v.033C17 15.09 17.87 16 18.975 16M24 29a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
